import type { KeyframeEntryT, SpanT } from '../studio-store/types';
export function isFrameInAnySpan(frameIndex: number, spans: SpanT[]): boolean {
  return spans.some(s => s.start <= frameIndex && frameIndex <= s.end);
}
export function hasPreviousFrameInSpan(frameIndex: number, spans: SpanT[]): boolean {
  return isFrameInAnySpan(frameIndex - 1, spans);
}
export function hasNextFrameInSpan(frameIndex: number, spans: SpanT[]): boolean {
  return isFrameInAnySpan(frameIndex + 1, spans);
}
export function isKeyframe(frameIndex: number, keyframes: KeyframeEntryT[]): boolean {
  return keyframes.some(k => k.frameIndex === frameIndex);
}
export function getKeyframeEntry(frameIndex: number, keyframes: KeyframeEntryT[]): KeyframeEntryT | undefined {
  return keyframes.find(k => k.frameIndex === frameIndex);
}
export function hasKeyframeInRange(start: number, end: number, keyframes: KeyframeEntryT[]): boolean {
  return keyframes.some(k => k.frameIndex >= start && k.frameIndex <= end);
}
export function removeKeyframeAtIndex(frameIndex: number, keyframes: KeyframeEntryT[]): KeyframeEntryT[] {
  return keyframes.filter(k => k.frameIndex !== frameIndex);
}
function rangeToFrameIndexes(span: SpanT): number[] {
  const frames: number[] = [];
  for (let frameIndex = span.start; frameIndex <= span.end; frameIndex++) {
    frames.push(frameIndex);
  }
  return frames;
}
export function diffFrameSpans(oldSpan: SpanT | undefined, newSpan: SpanT): {
  toDelete: number[];
  toWrite: number[];
} {
  const newFrames = rangeToFrameIndexes(newSpan);
  if (!oldSpan) {
    return {
      toDelete: [],
      toWrite: newFrames
    };
  }
  const newFrameSet = new Set(newFrames);
  const toDelete = rangeToFrameIndexes(oldSpan).filter(frameIndex => !newFrameSet.has(frameIndex));
  return {
    toDelete,
    toWrite: newFrames
  };
}